/*
 * @Author: your name
 * @Date: 2021-02-27 16:09:58
 * @LastEditTime: 2021-09-22 14:53:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-admin-web-master/src/main.js
 */
import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
import "./styles/element/index.css"
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import directives from "./directives";
import "@/styles/index.scss"; // global css
import App from "./App";
import router from "./router";
import store from "./store";

import "@/icons"; // icon
import "@/permission"; // permission control


// 引入echarts
import echarts from "@/common/ECharts/echarts.js";

// 挂载到vue实例中
Vue.prototype.$echarts = echarts

Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});

Vue.use(ElementUI, {
  locale
});
// console.log(store.getters.btns, 'btns')

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js